import { Contents } from '@components/article/Contents/Contents';
import { FunctionComponent, memo } from 'react';
import { Container } from './RenderHTMLText.styles';
import { RenderHTMLTextProps } from './RenderHTMLText.types';
import { serialize } from './renderToHTML';

const RenderHTMLTextComponent: FunctionComponent<RenderHTMLTextProps> = ({
  wysiwygData,
  className = '',
  ads,
}) => {
  const contentHeading = wysiwygData
    /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
    /* @ts-ignore */
    .filter((node) => node.type === 'heading')
    .filter((node) => {
      /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
      /* @ts-ignore */
      if (node.children.length === 1 && node.children[0].text === '') {
        return false;
      }

      return node;
    })
    .map((node) => {
      /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
      /* @ts-ignore */
      const differentChild = node.children.find((child) => child.type === 'link');

      /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
      /* @ts-ignore */
      return differentChild ? differentChild.children[0].text : node.children[0].text;
    });

  const serializedHtml = serialize({ children: wysiwygData }, ads);

  return (
    <Container className={`wysiwyg-text ${className}`}>
      {contentHeading.length > 4 && <Contents elements={contentHeading} />}
      {serializedHtml}
    </Container>
  );
};

export const RenderHTMLText = memo(RenderHTMLTextComponent);
